(function () {
  function initCustomTestimonials(section) {
    if (section.dataset.ctInit) return;
    section.dataset.ctInit = '1';

    /* ---- Inline video playback (replaces the image inside the card) ---- */
    var activeMedia = null; // tracks the currently-playing card's media element

    function restoreCard(media) {
      var original = media.dataset.originalHtml;
      if (original !== undefined) {
        media.innerHTML = original;
        rebindPlayButton(media);
      }
    }

    function rebindPlayButton(media) {
      var btn = media.querySelector('.custom-testimonials__play');
      if (btn) bindPlayButton(btn);
    }

    function stopActive() {
      if (!activeMedia) return;
      var video = activeMedia.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      var iframe = activeMedia.querySelector('iframe');
      if (iframe) {
        // Removing/re-setting the src is the reliable way to stop a YouTube/Vimeo embed
        iframe.src = iframe.src;
      }
      restoreCard(activeMedia);
      activeMedia = null;
    }

    function playInline(media, btn) {
      var nativeSrc = btn.getAttribute('data-video-native');
      var embedSrc = btn.getAttribute('data-video-embed');

      // Stop whatever else is currently playing (if it's a different card)
      if (activeMedia && activeMedia !== media) {
        stopActive();
      }

      // Save the original markup once so we can restore image + play button later
      if (media.dataset.originalHtml === undefined) {
        media.dataset.originalHtml = media.innerHTML;
      }

      if (nativeSrc) {
        var video = document.createElement('video');
        video.src = nativeSrc;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.className = 'custom-testimonials__inline-video';
        media.innerHTML = '';
        media.appendChild(video);
        var p = video.play();
        if (p && p.catch) p.catch(function () {});

        video.addEventListener('ended', function () {
          if (activeMedia === media) activeMedia = null;
        });
      } else if (embedSrc) {
        media.innerHTML =
          '<iframe class="custom-testimonials__inline-video" src="' + embedSrc +
          '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
      }

      activeMedia = media;
    }

    function bindPlayButton(btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var media = btn.closest('.custom-testimonials__media');
        if (media) playInline(media, btn);
      });
    }

    section.querySelectorAll('.custom-testimonials__play').forEach(bindPlayButton);

    /* ---- Carousel dots (works for both mobile 1-up and desktop N-up) ---- */
    var grid = section.querySelector('.custom-testimonials__grid');
    var dotsWrap = section.querySelector('.custom-testimonials__dots');

    if (grid && dotsWrap) {
      var cards = Array.prototype.slice.call(
        grid.querySelectorAll('.custom-testimonials__card')
      );

      function isCarousel() {
        return grid.scrollWidth - grid.clientWidth > 2;
      }

      function getMetrics() {
        var step = cards.length > 1 ? (cards[1].offsetLeft - cards[0].offsetLeft) : 0;
        var perView = step > 0 ? Math.max(1, Math.round(grid.clientWidth / step)) : 1;
        var pages = Math.max(1, Math.ceil(cards.length / perView));
        return { step: step, perView: perView, pages: pages, pageStep: step * perView };
      }

      function setActive(i) {
        var dots = dotsWrap.children;
        for (var d = 0; d < dots.length; d++) {
          dots[d].classList.toggle('is-active', d === i);
        }
      }

      function activeIndex(m) {
        var maxScroll = grid.scrollWidth - grid.clientWidth;
        if (grid.scrollLeft >= maxScroll - 2) return m.pages - 1;
        if (!m.pageStep) return 0;
        var i = Math.round(grid.scrollLeft / m.pageStep);
        return Math.min(Math.max(i, 0), m.pages - 1);
      }

      function buildDots() {
        if (!isCarousel()) {
          dotsWrap.style.display = 'none';
          dotsWrap.innerHTML = '';
          return;
        }

        var m = getMetrics();
        if (m.pages <= 1) {
          dotsWrap.style.display = 'none';
          dotsWrap.innerHTML = '';
          return;
        }

        dotsWrap.style.display = 'flex';

        if (dotsWrap.children.length !== m.pages) {
          dotsWrap.innerHTML = '';
          for (var i = 0; i < m.pages; i++) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'custom-testimonials__dot';
            dot.setAttribute('role', 'tab');
            dot.setAttribute('data-page', i);
            dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            dot.addEventListener('click', function () {
              var page = parseInt(this.getAttribute('data-page'), 10);
              var mm = getMetrics();
              var target = cards[Math.min(page * mm.perView, cards.length - 1)];
              if (target) {
                grid.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
              }
            });
            dotsWrap.appendChild(dot);
          }
        }

        setActive(activeIndex(m));
      }

      var scrollTimer;
      grid.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          if (!isCarousel()) return;
          setActive(activeIndex(getMetrics()));
        }, 80);
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(buildDots, 150);
      });

      buildDots();
    }
  }

  function initAll() {
    document.querySelectorAll('.custom-testimonials').forEach(initCustomTestimonials);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a section is added/re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.custom-testimonials');
    if (section) initCustomTestimonials(section);
  });
})();